// extracted by mini-css-extract-plugin
export default {"containerIssues":"ListIssues_containerIssues__zI5kd","containerFlex":"ListIssues_containerFlex__U8+F+","btnLoad":"ListIssues_btnLoad__XEfX9","loader":"ListIssues_loader__SnhYn"};